/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useLoading } from '../../../../../presentation/contexts/loading'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'
import DoubtEditor from '../../../../../presentation/pages/dashboard/configurations/doubts/editor'
import { makeDoubt } from '../../../../usecases/doubts/load-doubt-factory'

const MakeDoubtEditor = () => {
  const [initialFormData, setInitialFormData] = useState<any>(null)
  const { setHeader } = usePage()
  const { me } = useMe()
  const { onSetLoading } = useLoading()
  const { setIsShowing, setText, setType } = useSnackbar()

  const loadDoubts = async () => {
    if (!me) return
    const stablishmentId = me.stablishments[0].id
    const response = await makeDoubt(stablishmentId).load()
    setInitialFormData(response)
  }

  useEffect(() => {
    (async () => {
      setHeader({
        title: 'Dúvidas Frequentes',
        goTo: null,
      })
      onSetLoading(true)
      try {
        await loadDoubts()
      } catch (error) {
        console.log(error)
      } finally {
        onSetLoading(false)
      }
    })()
  }, [me])

  const dataForm = [
    {
      items: [
        {
          name: 'question',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          title: 'Pergunta',
          label: 'Pergunta',
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'answer',
          component: 'Textarea',
          value: '',
          placeholder: 'Digite aqui',
          title: 'Resposta',
          label: 'Resposta',
          required: true,
          validations: 'inputRequired',
        },
      ],
    },
  ]

  const onSubmit = async (values:any): Promise<void> => {
    const itemToSubmit = [...values.doubts]

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      await makeDoubt(stablishmentId).patch(itemToSubmit)
      await loadDoubts()
      setType('success')
      setText('Salvo com sucesso!')
      setIsShowing(true)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <DoubtEditor
      initialData={initialFormData}
      dataForm={dataForm}
      onSubmit={onSubmit}
    />
  )
}

export default MakeDoubtEditor
